//--------------- E-MAIL TRANSACIONAL (AMAZON SES) ---------------//
import api from "../../../shared/services/api";

const emailSesConfigService = {
  obter:        () => api.get("/integracoes/email-ses-config"),
  salvar:       (payload) => api.put("/integracoes/email-ses-config", payload),
  conta:        () => api.get("/integracoes/email-ses-config/conta"),
  identidades:  () => api.get("/integracoes/email-ses-config/identidades"),
  provisionar:  () => api.post("/integracoes/email-ses-config/eventos/provisionar"),
  testar:       (para) => api.post("/integracoes/email-ses-config/testar", { para }),
};

export default emailSesConfigService;
